// CarouselLinkCard.tsx or GamezopCarouselCard.tsx
'use client';

import { addEventParam, INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { KissanEventType } from '@ninjacart/nc-nk-store';
import { ResponsiveImage, View } from '@ninjacart/nc-nk-ui';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { useRef } from 'react';
import { Linking, Platform } from 'react-native';
import { Link } from 'solito/link';

export const ImageAdCard = ({ item, index }) => {
  const bannerHeight = 200;
  const { push } = useRouter();
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const onNavigate = async (item) => {
    onClickEvent();
    const url = `${item?.actionData?.content?.path}`;
    const canOpen = await Linking.canOpenURL(url);
    if (canOpen) {
      if (Platform.OS === 'web') {
        window.location.href = url;
      } else {
        Linking.openURL(url);
      }
    } else {
      push(`/${url}`);
    }
  };

  const onClickEvent = async () => {
    const imageClickEvent: INinjaEvent = {
      name: KissanEventType.HOMEPAGE_FEED_IMAGE_CLICKED,
      screenDetails: { screen: 'home feed page' },
      eventParams: [addEventParam('source page', 'home feed page'), addEventParam('index', index)],
    };
    enqueue(imageClickEvent);
  };

  return (
    <View onPress={() => onNavigate(item)} minHeight={180}>
      <Link href={`${item?.actionData?.content?.path}`} shallow>
        <View
          style={{
            height: bannerHeight,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ResponsiveImage
            src={item?.actionData?.content?.url}
            alt={item?.actionData?.content?.url}
            fit="fill"
          />
        </View>
      </Link>
    </View>
  );
};
